module.exports = __webpack_public_path__ + "img/qx_icon4.42d04bdb.png";